import axios from "axios";
import { toast } from "react-toastify";
import helper from "../services/helper";

const url = process.env.REACT_APP_BACKENDURL;

const fileApis = [
  "ConstructionledgerUploadBill",
  "ConstructionledgerUploadBillOne",
  "ConstructionledgerUploadBillTwo",
  "DcUploadBill",
];

const connectApi = async (endpoint = "/", payload = {}, method = "POST") => {
  try {
    const isFormData = fileApis.includes(endpoint);

    // 🔐 Get encrypted token from storage (decrypt before use)
    let token = localStorage.getItem(process.env.REACT_APP_TOKEN);

    if (token) {
      try {
        token = await helper.revertData(token); // decrypt token
      } catch {
        token = null;
      }
    }

    let headers = {
      "Content-Type": isFormData
        ? "multipart/form-data"
        : "application/json;charset=UTF-8",
    };

    if (token) {
      headers["x-access-token"] = token;
    }

    // 🔐 Encrypt payload except for file upload APIs
    const requestData = isFormData
      ? payload
      : { payload: await helper.convertData(payload) };

    const response = await axios({
      url: `${url}/${endpoint}`,
      method,
      headers,
      data: requestData,
    });

    // 🔓 Decrypt server response
    let ResponseData = response.data?.payload
      ? await helper.revertData(response.data.payload)
      : response.data;

    console.log(`Decoded API Response (${endpoint}) →`, ResponseData);

    // -------------------------------
    // 🔥 AUTO LOGOUT ON TOKEN BLOCK
    // -------------------------------

    if (ResponseData?.code === 305) {
      localStorage.clear();
      toast.error(
        ResponseData.message || "Your account is disabled. Contact Admin."
      );
      setTimeout(() => (window.location.href = "/"), 1500);
      return ResponseData;
    }

    if (ResponseData?.code === 304) {
      localStorage.clear();
      toast.error(
        ResponseData.message || "Token Expired"
      );
      setTimeout(() => (window.location.href = "/"), 1500);
      return ResponseData;
    }

    // Toast only if message exists
    if (
      ResponseData?.message &&
      typeof ResponseData.message === "string" &&
      ResponseData.message.trim().length > 0
    ) {
      ResponseData.status === true
        ? toast.success(ResponseData.message)
        : toast.error(ResponseData.message);
    }

    return (
      ResponseData || {
        status: false,
        message: "Invalid response from server",
      }
    );
  } catch (err) {
    console.error(`API Error (${endpoint}):`, err);

    const message =
      err?.response?.data?.message ||
      err?.message ||
      "Server Busy!";

    return { status: false, message };
  }
};

export default connectApi;
